/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiIssueNotificationLogsPageQuery } from './uiIssueNotificationLogsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiIssueNotificationLogsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
    "metadata": {},
    "name": "uiIssueNotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
